import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { TableLayout } from '../../Menu/Stock/containers/Layout';
import { TableHead, TableRow, TableCell, TableBody, Grid, Dialog } from '@material-ui/core';
import { isEmpty } from "lodash"
import InputText, { InputSelectNative } from '../../../commonModules/interface/form-input-inline';
import PopUp from '../../../commonModules/interface/PopUp';

class AgentUpdateForms extends Component {
    state = { 
        userQ: [{id: "default_user_question",name:"default_user_question"}],
        userR: "default_user_question",
        otherQ: [{id: "default_other_question",name:"default_other_question"}],
        otherR: "default_other_question",
        familyQ: [{id: "default_family_question",name:"default_family_question"}],
        familyR: "default_family_question",
        prospectQ: [{id: "default_prospect_question",name:"default_prospect_question"}],
        prospectR: "default_prospect_question",
        commercialQ: [{id: "default_commercial_question",name:"default_commercial_question"}],
        commercialR: "default_commercial_question",
    }
    componentDidMount = async () =>{
        //Get Actual Schema List
        console.log('[DEBUG], paygoGet All, load schema ');
        let listSchema = [];
        try {
            const response = await fetch('/schema/list', {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              },
              credentials: 'same-origin'
            });
            const resp = await response.json();
            console.log("[INFO], Response for list of all schema : , ");            
            console.log(resp);
            if (resp.content.lenght ==0) {
              console.log("[ERROR], getting schema getAll response ", resp)
              return;
            }
            //Parse content
            resp.content.map((item)=>{
                console.log(item);
                listSchema = listSchema.concat({id: item.id,name: item.name});
            });
            this.setState({
                userQ:  this.state.userQ.concat(listSchema),
                otherQ:this.state.otherQ.concat(listSchema),
                familyQ:this.state.familyQ.concat(listSchema),
                prospectQ:this.state.prospectQ.concat(listSchema),
                commercialQ:this.state.commercialQ.concat(listSchema)
            });
          } catch (err) {
            console.log("[ERROR], getting schema getAll data", err)
          }
          console.log("GET USERSCHEMA")
          console.log(this.props)
          try {
            const response = await fetch('/schema/get/userschema?id='+this.props.userID+'&type=agent', {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              },
              credentials: 'same-origin'
            });
            const resp = await response.json();
            console.log("[INFO], Response for list of all schema : , ");            
            console.log(resp);
            if (resp.content.lenght ==0) {
              console.log("[ERROR], getting schema getAll response ", resp)
              return;
            }

            this.setState({
                userR:  resp.content.user,
                otherR:resp.content.other,
                familyR:resp.content.family,
                prospectR:resp.content.prospect,
                commercialR:resp.content.commercial
            });
          } catch (err) {
            console.log("[ERROR], getting schema getAll data", err)
          }

    }
    handleSubmit = async () => {
        //Change FORMS
        console.log("Changement Questionnaire",this.state.commercialR)
        try {
            const response = await fetch('/schema/update/userschema', {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body:JSON.stringify({
                type: "agent",
                userID: this.props.userID,
                user:  this.state.commercialR,
                q1:this.state.userR,
                q2:this.state.familyR,
                q3:this.state.otherR,
                q4:this.state.prospectR
              }),
              credentials: 'same-origin'
            });
            const resp = await response.json();
            console.log("[INFO], Response for list of all schema : , ");            
            console.log(resp);
            if (resp.content === "OK") {
                this.props.cancel()
              return;
            }
            console.log("[ERROR], getting schema getAll response ", resp)

          } catch (err) {
            console.log("[ERROR], getting schema getAll data", err)
          }
    }

    render() {
        return (
            <PopUp
                title={this.props.formTitle}
                submitAction={this.handleSubmit}
                close={this.props.cancel}
                maxWidth="sm"
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <InputSelectNative
                            value={this.state.commercialR}
                            onChange={ e => this.setState({commercialR: e.target.value}) }
                            options={ this.state.commercialQ.map( item => 
                                <option key={item.id}  value={item.id}>{item.name} </option>
                            )}
                            label="Questionnaire Inscription Commercial"
                            labelWidth={260}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <InputSelectNative
                            value={this.state.userR}
                            onChange={e => this.setState({userR: e.target.value})}
                            options={this.state.userQ.map( item => 
                                <option key={item.id}  value={item.id}>{item.name} </option>
                            )}
                            label="Questionnaire utilisateur"
                            labelWidth={155}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <InputSelectNative
                            value={this.state.familyR}
                            onChange={e => this.setState({familyR: e.target.value})}
                            options={this.state.familyQ.map( item => 
                                <option key={item.id}  value={item.id}>{item.name} </option>
                            )}
                            label="Questionnaire Famille"
                            labelWidth={140}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <InputSelectNative
                            value={this.state.otherR}
                            onChange={e => this.setState({otherR: e.target.value})}
                            options={this.state.otherQ.map( item => 
                                <option key={item.id}  value={item.id}>{item.name} </option>
                            )}
                            label="Questionnaire Autre"
                            labelWidth={130}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <InputSelectNative
                            value={this.state.prospectR}
                            onChange={e => this.setState({prospectR: e.target.value})}
                            options={this.state.prospectQ.map( item => 
                                <option key={item.id}  value={item.id}>{item.name} </option>
                            )}
                            label="Questionnaire Prospect"
                            labelWidth={150}
                        />
                    </Grid>
                    {/* <button 
                        className="btn btn-success"
                        onClick={ this.handleSubmit }
                    >Valider</button>
                    <br/>
                    <button type="button" 
                    className="btn btn-default" 
                    onClick={()=> this.props.cancel()}> 
                        Annuler
                    </button> */}
                </Grid>
            </PopUp>
        );
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        CLIENTS: state.clients
    }
}

// function mapDispatchToProps(dispatch){
//     return bindActionCreators({
//         fetchAgents,
//         updateAgent,
//     }, dispatch)
// }
export default connect( mapStateToProps )(AgentUpdateForms);